<template>
  <div id="app">
    <!--    <img src="./assets/logo.png">-->
    <!--    <router-view/>-->
    <transition>
      <router-view v-wechat-title="$route.meta.title" v-if="!$route.meta.keepAlive && !isRouterAlive"></router-view>
    </transition>
    <transition>
      <keep-alive>
        <router-view v-wechat-title="$route.meta.title" v-if="$route.meta.keepAlive && !isRouterAlive" class="Router">
        </router-view>
      </keep-alive>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: false
    }
  },
  mounted () {

  },
  methods: {
    reload () {
      this.isRouterAlive = true
      this.$nextTick(function () {
        this.isRouterAlive = false
      })
    }
  }
}
</script>

<style>
#app {
  /* height: 100%;
  width: 100%;
  background: #f4f4f4; */
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue